import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { setStoredScaActionUrl, clearStoredScaActionUrl } from '../../logic/sca';

import {
  scaPreEnroll,
  scaRecipientEnroll,
  scaVerifyRedirectSuccess,
  scaVerifyRedirectFailure,
  scaVerificationReset,
} from '../../actions';

const SCADebugPanel = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  if (process.env.REACT_APP_DEBUG !== 'true') return null;

  const addRedirectParams = (controlStatus) => {
    const search = new URLSearchParams(location.search);
    search.set('controlStatus', controlStatus);
    history.replace({
      pathname: location.pathname,
      search: search.toString(),
    });
  };

  const mockUrl = 'https://example.com/mock-sca-action-url';

  const handleClearAll = () => {
    clearStoredScaActionUrl();
    dispatch(scaVerificationReset());
    // console.log('🧹 Cleared stored actionUrl and SCA state');
  };

  const handlePreEnroll = () => {
    clearStoredScaActionUrl();
    dispatch(scaPreEnroll());
    // console.log('🧪 PreEnroll state triggered');
  };

  const handleRecipientEnroll = () => {
    setStoredScaActionUrl(mockUrl);
    dispatch(scaRecipientEnroll());
    // console.log('Recipient enrollment triggered');
  };

  const handleExpired = () => {
    setStoredScaActionUrl(mockUrl, -1000);
    dispatch(scaRecipientEnroll());
    // console.log('Expired enrollment triggered');
  };

  const handleSuccess = () => {
    addRedirectParams('VALIDATED', 'SUCCEEDED');
    dispatch(
      scaVerifyRedirectSuccess({
        controlStatus: 'VALIDATED',
        mangoUser: { UserStatus: 'ACTIVE' },
      }),
    );
    // console.log('✅ SCA success state triggered');
  };

  const handleError = () => {
    addRedirectParams('FAILED', 'FAILED');
    dispatch(
      scaVerifyRedirectFailure({
        controlStatus: 'FAILED',
        mangoUser: { UserStatus: 'PENDING_USER_ACTION' },
      }),
    );
    // console.log('❌ SCA error state triggered');
  };

  return (
    <div style={{ padding: '2rem' }}>
      <Typography variant="subtitle2" gutterBottom>
        🔧 SCA Debug Panel (Dev Only)
      </Typography>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
        <Button variant="outlined" onClick={handlePreEnroll}>
          PreEnroll
        </Button>
        <Button variant="outlined" onClick={handleRecipientEnroll}>
          Recipient Enroll
        </Button>
        <Button variant="outlined" onClick={handleExpired}>
          Expired Link
        </Button>
        <Button variant="outlined" color="primary" onClick={handleSuccess}>
          Success
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleError}>
          Error
        </Button>
        <Button variant="outlined" onClick={handleClearAll}>
          Clear SCA State
        </Button>
      </div>
    </div>
  );
};

export default SCADebugPanel;
